import loadable from '@loadable/component';

export const HeaderNewbuildingRedesignedContainerLoadable = loadable(() =>
  import('./HeaderNewbuildingRedesigned').catch(/* istanbul ignore next */ () => ({ default: () => null })),
);
